document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.country-selector-link-wrapper').forEach(button => button.addEventListener('click', () => button.classList.toggle('active')))

  document.addEventListener('click', function (event) {
    if (event.target.closest('.country-selector-link-wrapper') === null) {
      document.querySelectorAll('.country-selector-link-wrapper').forEach(button => button.classList.remove('active'));
    }
  });

  document.querySelector('.back-to-menu').addEventListener('click', (event) => {
    event.stopPropagation();
    document.querySelector('.back-to-menu').parentNode.parentNode.classList.remove('active');
  });
});

